import { AtlassianLogo } from '@atlaskit/logo';
import { B400, B200, N40 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';

import React from 'react';
import { ContainerLayoutType } from '../../../../../model';
import { SideInfo, Signup, SocialSignup } from '../component';
import { ReducedRow } from '../styled';

/**
 * Default Layout
 * Includes basic header, side-information, and signup
 */

export function LayoutDefault(props: ContainerLayoutType) {
  return (
    <ReducedRow>
      <SocialSignup {...props}>
        <AtlassianLogo
          size="large"
          textColor={B400}
          iconColor={B200}
          iconGradientStart={B400}
          iconGradientStop={B200}
          className="logo-atl"
        />
        <FormAndInfoContainer>
          <ComponentWrapper className="side-info">
            <SideInfo {...props} />
          </ComponentWrapper>
          <ComponentWrapper>
            <Signup {...props} />
          </ComponentWrapper>
        </FormAndInfoContainer>
      </SocialSignup>
    </ReducedRow>
  );
}

const FormAndInfoContainer = styled.div`
  width: 83%;
  margin: auto;
  display: flex;
  flex-direction: row;
  flex-flow: nowrap;
  box-shadow: 0 2px 3px rgba(130, 130, 130, 0.2);
  border: 1px solid rgba(130, 130, 130, 0.2);

  @media only screen and (max-width: 769px) {
    width: 100%;
    flex-flow: row wrap;
  }
`;

const ComponentWrapper = styled.div`
  padding: 0 48px;
  margin: 48px 0;
  width: 50%;

  &:first-child {
    border-right: 1px solid ${N40};
  }

  &.side-info {
    @media only screen and (max-width: 769px) {
      order: 2;
    }
  }

  @media only screen and (max-width: 769px) {
    padding: 0 12px;
    margin: 16px 0;
    width: 100%;
    border-right: 0px solid transparent;

    form {
      max-width: initial;
    }
  }
`;
